import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import { selectSignalsAreBeingFetched } from "app/pages/sales-intelligence/sub-modules/signals/store/selectors";

export const useAreSignalsCountsLoading = (): boolean => {
    const areSignalsBeingFetched = useSelector(selectSignalsAreBeingFetched);
    const [hasFetchStarted, setHasFetchStarted] = useState(false);

    useEffect(() => {
        if (areSignalsBeingFetched) {
            setHasFetchStarted(true);
        }
    }, [areSignalsBeingFetched]);

    return !hasFetchStarted || areSignalsBeingFetched;
};
